<style lang="less">
.message-login-title {
  color: #e6a23c;
  font-size: 16px;
}
.message-login-txt {
  font-size: 16px;
}
.message-login-content {
  padding: 10px;
}
</style>
<template>
  <el-container class="layout">
    <el-header>
      <a href="javascript:;"
         @click="handleBackHome">
        <img :src="logoheader" />
        <template v-if="this.$route.name!='main'">
          <img :src="backhome" />
          <div>首页</div>
        </template>
      </a>
      <div class="header-title">
        <template v-if="this.$route.name!='main'">{{tenantName}} •</template>
        {{this.$route.meta.title}}
      </div>
      <div class="sign-out">
        <a class="wea"
           href="javascript:;"
           @click="showCalendar(0)">{{newDate}}{{JQ}}</a>
        <div class="wea city">
          <img src="./image/personLocation.png" />
          <span>{{city}}</span>
        </div>
        <a class="wea city-info"
           href="javascript:;"
           @click="showCalendar(1)">
          <img :src="wea_img" />
          <span>{{tem}}</span>℃
        </a>
        <!-- <div class="wea city-temp">
          <span>{{wea}}</span>
        </div>-->
        <a class="wea temp-detail"
           href="javascript:;"
           @click="showCalendar(1)">{{tem2}}~{{tem1}}℃</a>
        <span class="user">{{userName}}</span>
        <a href="javascript:;"
           @click="stop">
          <img src="./image/tuichu.png" />
          <span>退出</span>
        </a>
      </div>
    </el-header>
    <!--  -->
    <el-dialog class="calendardialog"
               :visible.sync="centerDialogVisible"
               :modal-append-to-body="false">
      <span class="el-icon-circle-close"
            @click="closeDialog(0)"></span>
      <iframe src="../../static/demo.html"
              width="598"
              height="430"
              frameborder="0"
              scrolling="auto"
              style="border-radius: 8px;"></iframe>
    </el-dialog>
    <el-dialog class="weadialog"
               :visible.sync="centerWeaDialogVisible"
               :modal-append-to-body="false">
      <span class="el-icon-circle-close"
            @click="closeDialog(1)"></span>
      <a class="more"
         href="http://www.weather.com.cn/weather40d/101190201.shtml"
         target="_blank">
        查看更多
        <span class="el-icon-d-arrow-right"></span>
      </a>
      <iframe scrolling="no"
              src="https://tianqiapi.com/api.php?style=tw&skin=pitaya"
              frameborder="0"
              width="300"
              height="500"
              allowtransparency="true"></iframe>
    </el-dialog>
    <el-main>
      <router-view />
    </el-main>
  </el-container>
</template>
<script>
import { localToken } from "@/libs/util";
import { MessageBox } from "element-ui";
import axios from "axios";

import bingbao from "@/assets/weather/bingbao.png";
import lei from "@/assets/weather/lei.png";
import qing from "@/assets/weather/qing.png";
import shachen from "@/assets/weather/shachen.png";
import wu from "@/assets/weather/wu.png";
import xue from "@/assets/weather/xue.png";
import yin from "@/assets/weather/yin.png";
import yu from "@/assets/weather/yu.png";
import yun from "@/assets/weather/yun.png";
import common from "@/libs/common";
import globConfig from "@/config/config";

import logoheader from "@/assets/logoheader.png";
import backhome from "@/assets/backhome.png";

// import calendar from "./main/calendar.vue";
import $ from "jquery";
export default {
  name: "layout",
  // components: {
  //   calendar
  // },
  data () {
    return {
      // 天气接口信息
      city: "",
      wea_img: qing,
      wea: "",
      tem: "",
      tem2: "",
      tem1: "",
      pic: {
        bingbao: bingbao,
        lei: lei,
        qing: qing,
        shachen: shachen,
        wu: wu,
        xue: xue,
        yin: yin,
        yu: yu,
        yun: yun
      },
      userName: "",
      tenantName: "",
      timer: null,
      logoheader: logoheader,
      backhome: backhome,
      JQ: "",
      newDate: "",
      centerDialogVisible: false,
      centerWeaDialogVisible: false
    };
  },
  methods: {
    handleBackHome () {
      this.$router.replace({ path: "/main" });
    },
    stop () {
      let that = this;
      const h = that.$createElement;
      MessageBox({
        message: h("div", null, [
          h("i", {
            class: "el-icon-warning message-login-title"
          }),
          h("span", { class: "message-login-txt" }, " 提示"),
          h("p", { class: "message-login-content" }, "您确认退出该系统？ ")
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            localToken.clearLocal();
            let tenant_id = localToken.getTenant();
            if (tenant_id && tenant_id != "undefined") {
              that.$router.push({
                path: "/" + tenant_id + "/login"
              });
            } else {
              that.$router.push({
                path: "/login"
              });
            }
            clearInterval(that.timer);
            that.timer = null;
            done();
          } else {
            done();
          }
        }
      });
    },
    getWeather () {
      let that = this;
      console.log("当前时间：", new Date());
      axios.get(globConfig.urlWeather).then(
        res => {
          that.city = res.data.city;
          that.wea_img = that.pic[res.data.wea_img];
          that.tem = res.data.tem;
          that.wea = res.data.wea;
          that.tem2 = res.data.tem2;
          that.tem1 = res.data.tem1;
          console.log(res);
        },
        err => { }
      );
    },
    showCalendar (val) {
      if (val) {
        this.centerWeaDialogVisible = true;
      } else {
        this.centerDialogVisible = true;
      }
    },
    closeDialog (val) {
      if (val) {
        this.centerWeaDialogVisible = false;
      } else {
        this.centerDialogVisible = false;
      }
    }
  },
  mounted () {
    let that = this;
    that.userName = localToken.getUser();
    that.tenantName = localToken.getTenantname();
    that.getWeather();
    that.timer = window.setInterval(() => {
      setTimeout(that.getWeather(), 0);
    }, 3600000);
    // 节气
    function SolarTerm (DateGL) {
      var SolarTermStr = new Array(
        "小寒",
        "大寒",
        "立春",
        "雨水",
        "惊蛰",
        "春分",
        "清明",
        "谷雨",
        "立夏",
        "小满",
        "芒种",
        "夏至",
        "小暑",
        "大暑",
        "立秋",
        "处暑",
        "白露",
        "秋分",
        "寒露",
        "霜降",
        "立冬",
        "小雪",
        "大雪",
        "冬至"
      );
      var DifferenceInMonth = new Array(
        1272060,
        1275495,
        1281180,
        1289445,
        1299225,
        1310355,
        1321560,
        1333035,
        1342770,
        1350855,
        1356420,
        1359045,
        1358580,
        1355055,
        1348695,
        1340040,
        1329630,
        1318455,
        1306935,
        1297380,
        1286865,
        1277730,
        1274550,
        1271556
      );
      var DifferenceInYear = 31556926;
      var BeginTime = new Date(1901 / 1 / 1);
      BeginTime.setTime(947120460000);
      for (; DateGL.getFullYear() < BeginTime.getFullYear();) {
        BeginTime.setTime(BeginTime.getTime() - DifferenceInYear * 1000);
      }
      for (; DateGL.getFullYear() > BeginTime.getFullYear();) {
        BeginTime.setTime(BeginTime.getTime() + DifferenceInYear * 1000);
      }
      for (var M = 0; DateGL.getMonth() > BeginTime.getMonth(); M++) {
        BeginTime.setTime(BeginTime.getTime() + DifferenceInMonth[M] * 1000);
      }
      if (DateGL.getDate() > BeginTime.getDate()) {
        BeginTime.setTime(BeginTime.getTime() + DifferenceInMonth[M] * 1000);
        M++;
      }
      if (DateGL.getDate() > BeginTime.getDate()) {
        BeginTime.setTime(BeginTime.getTime() + DifferenceInMonth[M] * 1000);
        M == 23 ? (M = 0) : M++;
      }
      var JQ = " ";
      if (DateGL.getDate() == BeginTime.getDate()) {
        JQ += SolarTermStr[M];
      }
      return JQ;
    }
    function DaysNumberofDate (DateGL) {
      return (
        parseInt(
          (Date.parse(DateGL) - Date.parse(DateGL.getFullYear() + "/1/1")) /
          86400000
        ) + 1
      );
    }
    function CnDateofDate (DateGL) {
      var CnData = new Array(
        0x16,
        0x2a,
        0xda,
        0x00,
        0x83,
        0x49,
        0xb6,
        0x05,
        0x0e,
        0x64,
        0xbb,
        0x00,
        0x19,
        0xb2,
        0x5b,
        0x00,
        0x87,
        0x6a,
        0x57,
        0x04,
        0x12,
        0x75,
        0x2b,
        0x00,
        0x1d,
        0xb6,
        0x95,
        0x00,
        0x8a,
        0xad,
        0x55,
        0x02,
        0x15,
        0x55,
        0xaa,
        0x00,
        0x82,
        0x55,
        0x6c,
        0x07,
        0x0d,
        0xc9,
        0x76,
        0x00,
        0x17,
        0x64,
        0xb7,
        0x00,
        0x86,
        0xe4,
        0xae,
        0x05,
        0x11,
        0xea,
        0x56,
        0x00,
        0x1b,
        0x6d,
        0x2a,
        0x00,
        0x88,
        0x5a,
        0xaa,
        0x04,
        0x14,
        0xad,
        0x55,
        0x00,
        0x81,
        0xaa,
        0xd5,
        0x09,
        0x0b,
        0x52,
        0xea,
        0x00,
        0x16,
        0xa9,
        0x6d,
        0x00,
        0x84,
        0xa9,
        0x5d,
        0x06,
        0x0f,
        0xd4,
        0xae,
        0x00,
        0x1a,
        0xea,
        0x4d,
        0x00,
        0x87,
        0xba,
        0x55,
        0x04
      );
      var CnMonth = new Array();
      var CnMonthDays = new Array();
      var CnBeginDay;
      var LeapMonth;
      var Bytes = new Array();
      var I;
      var CnMonthData;
      var DaysCount;
      var CnDaysCount;
      var ResultMonth;
      var ResultDay;
      var yyyy = DateGL.getFullYear();
      var mm = DateGL.getMonth() + 1;
      var dd = DateGL.getDate();
      if (yyyy < 100) yyyy += 1900;
      if (yyyy < 1997 || yyyy > 2020) {
        return 0;
      }
      Bytes[0] = CnData[(yyyy - 1997) * 4];
      Bytes[1] = CnData[(yyyy - 1997) * 4 + 1];
      Bytes[2] = CnData[(yyyy - 1997) * 4 + 2];
      Bytes[3] = CnData[(yyyy - 1997) * 4 + 3];
      if ((Bytes[0] & 0x80) != 0) {
        CnMonth[0] = 12;
      } else {
        CnMonth[0] = 11;
      }
      CnBeginDay = Bytes[0] & 0x7f;
      CnMonthData = Bytes[1];
      CnMonthData = CnMonthData << 8;
      CnMonthData = CnMonthData | Bytes[2];
      LeapMonth = Bytes[3];
      for (I = 15; I >= 0; I--) {
        CnMonthDays[15 - I] = 29;
        if (((1 << I) & CnMonthData) != 0) {
          CnMonthDays[15 - I]++;
        }
        if (CnMonth[15 - I] == LeapMonth) {
          CnMonth[15 - I + 1] = -LeapMonth;
        } else {
          if (CnMonth[15 - I] < 0) {
            CnMonth[15 - I + 1] = -CnMonth[15 - I] + 1;
          } else {
            CnMonth[15 - I + 1] = CnMonth[15 - I] + 1;
          }
          if (CnMonth[15 - I + 1] > 12) {
            CnMonth[15 - I + 1] = 1;
          }
        }
      }
      DaysCount = DaysNumberofDate(DateGL) - 1;
      if (DaysCount <= CnMonthDays[0] - CnBeginDay) {
        if (yyyy > 1901 && CnDateofDate(new Date(yyyy - 1 + "/12/31")) < 0) {
          ResultMonth = -CnMonth[0];
        } else {
          ResultMonth = CnMonth[0];
        }
        ResultDay = CnBeginDay + DaysCount;
      } else {
        CnDaysCount = CnMonthDays[0] - CnBeginDay;
        I = 1;
        while (
          CnDaysCount < DaysCount &&
          CnDaysCount + CnMonthDays[I] < DaysCount
        ) {
          CnDaysCount += CnMonthDays[I];
          I++;
        }
        ResultMonth = CnMonth[I];
        ResultDay = DaysCount - CnDaysCount;
      }
      if (ResultMonth > 0) {
        return ResultMonth * 100 + ResultDay;
      } else {
        return ResultMonth * 100 - ResultDay;
      }
    }
    // function CnMonthofDate(DateGL) {
    //   var CnMonthStr = new Array(
    //     "零",
    //     "正",
    //     "二",
    //     "三",
    //     "四",
    //     "五",
    //     "六",
    //     "七",
    //     "八",
    //     "九",
    //     "十",
    //     "冬",
    //     "腊"
    //   );
    //   var Month;
    //   Month = parseInt(CnDateofDate(DateGL) / 100);
    //   if (Month < 0) {
    //     return "闰" + CnMonthStr[-Month] + "月";
    //   } else {
    //     return CnMonthStr[Month] + "月";
    //   }
    // }
    function CnEra (YYYY) {
      var Tiangan = new Array(
        "甲",
        "乙",
        "丙",
        "丁",
        "戊",
        "己",
        "庚",
        "辛",
        "壬",
        "癸"
      );
      var Dizhi = new Array(
        "子",
        "丑",
        "寅",
        "卯",
        "辰",
        "巳",
        "午",
        "未",
        "申",
        "酉",
        "戌",
        "亥"
      );
      return Tiangan[YYYY % 10] + Dizhi[YYYY % 12];
    }
    // function CnYearofDate(DateGL) {
    //   var YYYY = DateGL.getFullYear();
    //   var MM = DateGL.getMonth() + 1;
    //   var CnMM = parseInt(Math.abs(CnDateofDate(DateGL)) / 100);
    //   if (YYYY < 100) YYYY += 1900;
    //   if (CnMM > MM) YYYY--;
    //   YYYY -= 1864;
    //   return CnEra(YYYY) + "年";
    // }
    function CnMonthofDate (DateGL) {
      var CnMonthStr = new Array(
        "零",
        "正",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二"
        // "冬",
        // "腊"
      );
      var Month;
      Month = parseInt(CnDateofDate(DateGL) / 100);
      if (Month < 0) {
        return "闰" + CnMonthStr[-Month] + "月";
      } else {
        return CnMonthStr[Month] + "月";
      }
    }

    function CnDayofDate (DateGL) {
      var CnDayStr = new Array(
        "零",
        "初一",
        "初二",
        "初三",
        "初四",
        "初五",
        "初六",
        "初七",
        "初八",
        "初九",
        "初十",
        "十一",
        "十二",
        "十三",
        "十四",
        "十五",
        "十六",
        "十七",
        "十八",
        "十九",
        "二十",
        "廿一",
        "廿二",
        "廿三",
        "廿四",
        "廿五",
        "廿六",
        "廿七",
        "廿八",
        "廿九",
        "三十"
      );
      var Day;
      Day = Math.abs(CnDateofDate(DateGL)) % 100;
      return CnDayStr[Day];
    }
    function CnDateofDateStr (DateGL) {
      if (CnMonthofDate(DateGL) == "零月") return "　请调整您的计算机日期!";
      else
        return (
          // CnYearofDate(DateGL) +
          // " " +
          "农历" + CnMonthofDate(DateGL) + CnDayofDate(DateGL)
        );
    }
    // var DateGL = new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000);
    // var date = "2020-01-25 17:59:00";
    // date = date.substring(0, 19);
    // date = date.replace(/-/g, "/");
    // var timestamp = new Date(date).getTime();
    // // 根据毫秒数构建 Date 对象
    // var DateGL = new Date(timestamp);
    var DateGL = new Date("2021-02-01");
    that.JQ = SolarTerm(DateGL); // 节气
    that.newDate = CnDateofDateStr(DateGL); // 农历日期
  }
};
</script>
<style lang="less">
.el-container.is-vertical.layout {
  height: 100%;
  > .el-header {
    height: 7% !important;
    min-height: 43px;
    max-height: 60px;
    display: flex;
    align-items: center;
    background-color: #3f78e3;
    color: #fff;
    > a {
      z-index: 2;
      height: 75%;
      display: flex;
      align-items: center;
      color: #fff;
      img {
        height: 100%;
        max-height: 34px;
      }
      img:nth-child(2) {
        max-height: 32px;
        margin-left: 30px;
      }
    }
    a,
    a:focus,
    a:active,
    div {
      outline: none;
      color: #fff;
      text-decoration: none//underline;
    }
    .header-title {
      font-size: 18px;
      font-weight: 500;
      position: absolute;
      width: 100%;
      z-index: 1;
    }
    .sign-out {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .user {
        margin-right: 20px;
      }
      a {
        z-index: 2;
        display: flex;
        align-items: center;
      }
      a:focus,
      a:active,
      span {
        outline: none;
        color: #fff;
        text-decoration: none//underline;
      }
      .wea {
        display: flex;
        height: 40px;
        align-items: center;
        margin-right: 16px;
        letter-spacing: 1px;
      }
      .city {
        height: auto;
        padding: 4px 10px 4px 8px;
        background-color: #ffffff1f;
        border-radius: 16px;
        font-size: 16px;
        margin-right: 10px;
      }
      .city-info {
        img {
          height: 32px;
        }
        span {
          font-size: 18px;
        }
      }
      .temp-detail {
        margin-right: 40px;
      }
    }
  }
  > .el-main {
    padding: 0px;
    background-color: #f7f7f7;
  }

  //日期弹出框
  .calendardialog .el-dialog {
    width: 598px !important;
    border-radius: 8px;
    .el-dialog__header {
      display: none !important;
    }
    .el-dialog__body {
      width: 598px !important;
      height: 430px !important;
      padding: 0px !important;
      border-radius: 8px;
      .el-icon-circle-close {
        position: absolute;
        top: -26px;
        right: -60px;
        color: #fff;
        font-size: 28px;
        font-weight: 500;
        cursor: pointer;
      }
    }
  }
  .weadialog .el-dialog {
    width: 498px !important;
    border-radius: 8px;
    .el-dialog__header {
      display: none !important;
    }
    .el-dialog__body {
      width: 498px !important;
      height: 500px !important;
      padding: 0px !important;
      border-radius: 8px;
      .el-icon-circle-close {
        position: absolute;
        top: -26px;
        right: -60px;
        color: #fff;
        font-size: 28px;
        font-weight: 500;
        cursor: pointer;
      }
      .more {
        color: #606266;
        position: absolute;
        right: 0px;
        padding: 15px;
        outline: none;
        text-decoration: none;
      }
    }
    iframe {
      width: 90%;
      margin: 0 5%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/layout.back.vue